import React, { useRef, useState } from "react";
import titleImg from "../../../../assets/images/event-2024/title-event.png";
import collectionImg from "../../../../assets/images/event-2024/collection.png";
import xoDiemImg from "../../../../assets/images/event-2024/xo-diem.png";
import xoPhaoImg from "../../../../assets/images/event-2024/xo-phao.png";
import iconLightUp from "../../../../assets/images/event-2024/light-up-icon.svg";
import bgBtnAction from "../../../../assets/images/event-2024/btn-action.png";
import iconGift from "../../../../assets/images/event-2024/gift-icon.png";
import iconSpark from "../../../../assets/images/event-2024/spark.png";
import iconShell from "../../../../assets/images/event-2024/shell.png";
import iconErrorVo from "../../../../assets/images/event-2024/popup/F Pop up 8.png";
import GiftSupper from "../Components/GiftSupper";
import Firework from "../Components/firework";
import { useTranslation } from "react-i18next";
import { getCheckStatusEvent, getStatisticEvent } from "dataLayer/product";
import { useQuery } from "react-query";
import { usePairingEventNewYear } from "dataLayer/user";
import { PATHS } from "@config/constants";
import { useHistory } from "react-router-dom";
import { isLoggedIn } from "@utils/cookie";
import PopupComponents from "../Components/PopupComponents";
import iconOverAll from "../../../../assets/images/event-2024/popup/F Pop up 6.png";
import iconErrorDiem from "../../../../assets/images/event-2024/popup/f-pop-up-3.png";
import iconSuccess from "../../../../assets/images/event-2024/popup/f-pop-up-1.png";
import iconSuccessBoxNew from "../../../../assets/images/event-2024/popup/F Pop up 1 .png";
import Snow from "../Components/animtion/Snow";
import PopupLogin from "../Components/PopupLogin";

export default function NavidadExplosive() {
  const { t } = useTranslation();
  const dataPopUp = useRef({
    backgroundPopup: "",
    title: "",
    btnAction: {
      action: () => {},
      title: "",
    },
    description: "",
  });
  const history = useHistory();
  const [isClickedFirework, setIsClickedFirework] = useState(false);
  const [isFlash, setIsFlash] = useState(false);
  const { data: statisticEvent = {}, refetch } = useQuery(getStatisticEvent());
  const { data: statusEvent, refetch: refetchStatus } = useQuery(getCheckStatusEvent());
  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    mutate: mutateWork,
    data,
    isSuccess,
    error,
    isLoading,
  } = usePairingEventNewYear();
  console.log(111222, statusEvent);

  const handleFirework = async () => {
    const isLogin = isLoggedIn();
    if (!isLogin) {
      return setIsModalOpen(true);
    }

    if (!statisticEvent?.spark && !statisticEvent?.shell) {
      console.log("hết cả 2");

      dataPopUp.current = {
        backgroundPopup: iconOverAll,
        title:
          "¡Te quedaste sin Fósforos ni Fuegos Artificiales para encender! ¡Reúnelos ahora para que la Navidad cobre vida!",
        btnAction: {
          action: () => {
            history.push(PATHS.BID2_PAGE);
          },
          title: "Puja ahora",
        },
        btnAction2: {
          action: () => {
            history.push(PATHS.ACCOUNT_PAGE, { isPagePack: true });
          },
          title: "Compra paquetes",
        },
        description: "",
      };
      return setOpen(true);
    }

    if (!statisticEvent?.spark) {
      console.log("hết diêm");
      dataPopUp.current = {
        backgroundPopup: iconErrorDiem,
        title:
          "¡Te quedaste sin Fósforos para encender tus Fuegos Artificiales! ¡Haz un puja para obtener más Fósforos y poner en marca el Espectáculo de Fuegos Artificiales!",
        btnAction: {
          action: () => {
            history.push(PATHS.BID2_PAGE);
          },
          title: "Puja ahora",
        },
      };
      return setOpen(true);
    }

    if (!statisticEvent?.shell) {
      console.log("hết vỏ pháo");
      dataPopUp.current = {
        backgroundPopup: iconErrorVo,
        title:
          "¿No quedan Fuegos Artificiales? ¡Compra más paquetes para ganar más Fuegos Artificiales y prepárate para iluminar el cielo!",
        btnAction: {
          action: () => {
            history.push(PATHS.ACCOUNT_PAGE, { isPagePack: true });
          },
          title: "Compra paquetes",
        },
      };

      return setOpen(true);
    }
    // success
    mutateWork(
      {},
      {
        onSuccess: (data) => {
          console.log(data);

              setIsClickedFirework(true);
              setTimeout(() => setIsClickedFirework(false), 1000);
              setTimeout(() => setIsFlash(true), 5000);
              setTimeout(() => setIsFlash(false), 6000);
              setTimeout(() => setOpen(true), 2000);

              if (data?.data?.superBoxNew){
                dataPopUp.current = {
                  backgroundPopup: iconSuccessBoxNew,
                  title: `¡Felicitaciones! ¡Encendiste con éxito ${
                    statisticEvent?.spark < statisticEvent?.shell
                      ? statisticEvent?.spark
                      : statisticEvent?.shell
                  } Fuegos artificiales y obtuviste ${
                    data?.data?.superBoxNew
                  } Súper Caja Navideña por ${
                    data?.data?.superBoxNew
                  } objetivo!`,
                  isHiddenBtnAction: true,
                  description:
                    "¡Alcanza la meta del Espectáculo de Fuegos Artificiales (50, 100 y más) para obtener Súper Cajas Navideñas llenas de recompensas premium!",
                };
              } else{
                dataPopUp.current = {
                  backgroundPopup: iconSuccess,
                  title: `¡Felicitaciones! ¡Has encendido con éxito ${
                    statisticEvent?.spark < statisticEvent?.shell
                      ? statisticEvent?.spark
                      : statisticEvent?.shell
                  } Fuegos Artificiales, llevando la celebración mágica en esta Navidad`,
                   description: "¡Alcanza la meta del Espectáculo de Fuegos Artificiales (50, 100 y más) para obtener Súper Cajas Navideñas llenas de recompensas premium!",
                  isHiddenBtnAction: true,
                };
              }

          refetch();
          refetchStatus();
        },
      }
    );


  };

  const handleBuyEquip = (url) => {
    if (PATHS.ACCOUNT_PAGE === url) {
      const isLogin = isLoggedIn();
      if (!isLogin) {
        return history.push(PATHS.LOGIN_PAGE);
      }
      return history.push(url, { isPagePack: true });
    }
    history.push(url);
  };

  return (
    <div className="navidad-explosive_container position-relative">
      <PopupLogin isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      {open ? (
        <PopupComponents
          backgroundPopup={dataPopUp.current?.backgroundPopup}
          open={open}
          setOpen={setOpen}
          title={dataPopUp.current?.title}
          btnAction={dataPopUp.current?.btnAction}
          btnAction2={dataPopUp.current?.btnAction2}
          description={dataPopUp.current?.description}
          isHiddenBtnAction={dataPopUp.current?.isHiddenBtnAction}
        />
      ) : null}
      <Snow />
      <Firework openFirework={isClickedFirework} />
      <div className="title-navidad">
        <img src={titleImg} alt="title" className="img-title-navidad" />
        <div className="navidad-collection">
          <div className={`position-relative ${isFlash ? "flash" : ""}`}>
            <div className="navidad-collection_content">
              {t("event_2024.navidad-explosive.your_collection")}
            </div>
            <img
              src={collectionImg}
              alt="collection"
              className="img-collection"
            />
            <div className="navidad-collection_total">
              x{statisticEvent.firework || 0}
            </div>
          </div>
        </div>
      </div>

      <div className="light-up_container">
        <div>
          <div className="position-relative light-up_container-item">
            <img src={xoDiemImg} alt="" className="icon-xo-diem" />
            <div className="light-up-total">{statisticEvent.spark}</div>
          </div>
          <div className="box-icon-spark">
            <img
              src={iconSpark}
              alt=""
              className={`icon-spark ${isClickedFirework ? "fly" : ""}`}
            />
          </div>
          <div className="position-relative title-btn-container">
            <div
              className="hover-item__img"
              onClick={() => handleBuyEquip(PATHS.BID2_PAGE)}
            >
              <img src={bgBtnAction} alt="" />
              <div className="title-btn-action">
                {t("event_2024.navidad-explosive.bid_now").toUpperCase()}
              </div>
            </div>
            <div className="btn-action-detail">
              {t("event_2024.navidad-explosive.place_more_bids")}
            </div>
          </div>
        </div>
        <div className="position-relative">
          <div className="light-up">
            <img
              onClick={handleFirework}
              src={iconLightUp}
              alt=""
              className="icon-light-up"
            />
            <div className="title-light-up btn-action-detail">
              {t("event_2024.navidad-explosive.click_to")}
              <span className="fireworks">
                {t("event_2024.navidad-explosive.light_up")}
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="position-relative light-up_container-item">
            <img src={xoPhaoImg} alt="" className="icon-xo-phao" />
            <div className="light-up-total">{statisticEvent.shell || 0}</div>
          </div>
          <div className="box-icon-shell">
            <img
              src={iconShell}
              alt=""
              className={`icon-shell ${isClickedFirework ? "fly" : ""}`}
            />
          </div>
          <div className="position-relative title-btn-container">
            <div
              className="hover-item__img"
              onClick={() => handleBuyEquip(PATHS.ACCOUNT_PAGE)}
            >
              <img src={bgBtnAction} alt="" />
              <div className="title-btn-action">
                {t("event_2024.navidad-explosive.buy_package").toUpperCase()}
              </div>
            </div>
            <div className="btn-action-detail">
              {t("event_2024.navidad-explosive.buy_more_packages")}
            </div>
          </div>
        </div>
      </div>

      <div className="footer-event">
        <div className="girft-icon">
          <img src={iconGift} alt="" />
        </div>
        <div className="footer-right-event">
          <GiftSupper statusEvent={statusEvent} classItem="zoom-in-out-box" />
          <div className="content-super">
            {t("event_2024.navidad-explosive.unwrap")}
          </div>
        </div>
      </div>
    </div>
  );
}
